// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XVWW","search":"Settings_search__2gs1q","filter":"Settings_filter__1ORnp"};